var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.45V1.55C1 1.40413 1.06364 1.26424 1.17692 1.16109C1.29019 1.05795 1.44383 1 1.60403 1H14.7709C14.9722 1 15.1615 1.09167 15.2742 1.24475L18.8984 6.19475C18.9647 6.28513 19 6.39135 19 6.5C19 6.60865 18.9647 6.71487 18.8984 6.80525L15.2742 11.7552C15.219 11.8307 15.1441 11.8925 15.0563 11.9352C14.9685 11.9779 14.8704 12.0001 14.7709 12H1.60403C1.52471 12 1.44616 11.9858 1.37288 11.9581C1.29959 11.9305 1.23301 11.89 1.17692 11.8389C1.12083 11.7878 1.07633 11.7272 1.04598 11.6605C1.01562 11.5937 1 11.5222 1 11.45Z",
    stroke: "#DCDCEC",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabel);
export default __webpack_public_path__ + "static/media/label.25cdffdbb7f48c8f0f45a74ce54d76d1.svg";
export { ForwardRef as ReactComponent };